import { reduxForm } from 'redux-form/immutable'
import { List, Map } from 'immutable'
import { connect } from 'react-redux'

import { createReviewsSurvey } from 'store/entities/reviewsSurveys/actions'
import { getReviewsSurveyById } from 'store/entities/reviewsSurveys/selectors'

import { parseMinAndMaxFieldsReviewers } from 'helpers/reviews'
import ReviewsSurveyForm, { validateForm } from '../ReviewsSurveyForm'

export const initialCompetency = Map({
  name: '',
  questions: List([Map({ userQuestion: '', reviewerQuestion: '' })]),
})

export const REVIEWS_SURVEY_CREATE_FORM = 'REVIEWS_SURVEY_CREATE_FORM'

const formProps = {
  form: REVIEWS_SURVEY_CREATE_FORM,
  validate: validateForm,
  onSubmit: (values: any, dispatch: any) => {
    const data = parseMinAndMaxFieldsReviewers(values.toJS())
    dispatch(createReviewsSurvey(data))
  },
  title: 'New Survey',
}

const initialVal = Map({
  participantWelcomeText:
    'You are being asked to participate in a 360-degree review assessment.\n' +
    'Your responses and the responses of your reviewers (except for your superiors) will be completely anonymous. \n' +
    'The survey will only take about 5-10 minutes, yet may have a lasting influence on your growth and development.\n' +
    'Thank you for your participation.',
  reviewerWelcomeText:
    'You are being asked to participate in a 360-degree review assessment.\n' +
    'Your responses and the responses of your reviewers (except for your superiors) will be completely anonymous. \n' +
    'The survey will only take about 5-10 minutes, yet may have a lasting influence on your growth and development.\n' +
    'Thank you for your participation.',
  participantInstructions:
    'Thank you, <@UserFirstName>\n' +
    'The first step is to evaluate yourself as a leader. \n' +
    'This self-evaluation will be included in your feedback report at the *leadership workshop* so you can compare how you and others view your leadership skills. You will complete a similar assessment in six months and your final report will show your progress.',
  reviewerInstructions:
    'Thank you, <@ReviewerFirstName>\n' +
    'The first step is to evaluate <@UserFirstName>  as a leader. \n' +
    'This evaluation will be included in your feedback report at the *leadership workshop* so you can compare how you and others view your leadership skills. You will complete a similar assessment in six months and your final report will show your progress.',
  nominationInstructions:
    'The next step is to nominate several individuals who will provide feedback for you. \n' +
    'When possible, select individuals who would give you the most honest feedback on your leadership.',
  superiorMin: '1',
  superiorMax: '2',
  superiorInstructions: '',
  peerMin: '1',
  peerMax: '2',
  peerInstructions: '',
  employeeMin: '1',
  employeeMax: '2',
  employeeInstructions: '',
  participantEndText: 'Thank you <@UserFirstName>',
  reviewerEndText: 'Thank you <@ReviewerFirstName>',
  competenciesQuestions: List([initialCompetency, initialCompetency, initialCompetency]),
})

const mapStateToProps = (state: any, { location: { state: stateRouter } }: any) => {
  let initialValues =
    stateRouter && stateRouter.reviewsSurveyId
      ? getReviewsSurveyById(stateRouter.reviewsSurveyId)(state)
          .delete('id')
          .delete('usedBy')
          .set('isPublished', false)
          .set('organizationId', null)
      : initialVal
  return {
    isEditForm: false,
    initialValues,
  }
}

// @ts-ignore
export default connect(mapStateToProps)(reduxForm(formProps)(ReviewsSurveyForm))
